import SocialSubscriptionErrorModal from '.';

export const loadSocialSubscriptionErrorModal = () => {
  new SocialSubscriptionErrorModal(
    'subscription-error',
    'jr-modal-wrapper',
  ).init();
}
